import React, { useState } from "react";

function MainContent() {
    const [showInfo, setShowInfo] = useState(false);

    const handleButtonClick = () => {
        setShowInfo(true);
    };

    return (
        <main className="content">
            <div className="info">
                <h1>Rozwiń skrzydła w świecie online!</h1>
                <div className="tagline">
                    Profesjonalne strony internetowe dla Twojego biznesu
                </div>
                <div className="main-text">
                    <p>
                        Czy wiesz, że profesjonalna strona internetowa to Twoja najlepsza
                        wizytówka w sieci?
                    </p>
                    <div className="features">
                        <button className="feature">
                            <span className="feature-icon">🌐</span>
                            <span>Dostępność 24/7 dla Twoich klientów</span>
                        </button>
                        <button className="feature">
                            <span className="feature-icon">💼</span>
                            <span>Profesjonalny wizerunek Twojej firmy</span>
                        </button>
                        <button className="feature">
                            <span className="feature-icon">📱</span>
                            <span>Responsywność na wszystkich urządzeniach</span>
                        </button>
                    </div>
                    <p className="cta-text">
                        Nie czekaj - zrób pierwszy krok w stronę rozwoju swojej marki!
                    </p>
                </div>
                <button className="get_more_info" onClick={handleButtonClick}>
                    Rozpocznij swoją podróż!
                </button>
                {showInfo && (
                    <div className="additional-info">
                        <p>
                            <hr></hr>
                            Gratulacje! Właśnie zrobiłeś pierwszy krok w stronę sukcesu online.
                            <br></br>
                            Nasza firma oferuje kompleksowe usługi tworzenia stron internetowych,
                            <br></br>
                            które pomogą Ci wyróżnić się w sieci. Nasze strony są nie tylko estetyczne,
                            <br></br>
                            ale także funkcjonalne i dostosowane do potrzeb Twojego biznesu.
                            <br></br>
                            Skontaktuj się z nami, aby dowiedzieć się więcej o naszych usługach!
                            <hr></hr>
                        </p>
                    </div>
                )}
            </div>
        </main>
    );
}

export default MainContent;
